<template>
  <div class="container">
    <div class="col-lg-12 d-flex justify-content-center pb-3 mb-5 m-top" @click="redirectBanner()">
      <img
        :src="imageSrc"
        :alt="imageAlt"
        :width="isMobile ? 369 : 1254"
        :height="isMobile ? 45 : 124"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import imagePt from 'assets/img/fernada-campos-v2-gratis-pt-desktop.webp'
  import imageEn from 'assets/img/fernada-campos-v2-gratis-en-desktop.webp'
  import imagePtMobile from 'assets/img/fernanda-campos-v2-gratis-pt-mobile.webp'
  import imageEnMobile from 'assets/img/fernanda-campos-v2-gratis-en-mobile.webp'
  import { isMobile } from '../../views/shared/utils/mobile'
  import { localeStore } from '../../stores/locale'

  const storeLocale = localeStore()

  const imageAlt = computed(() => {
    if (storeLocale.locale === 'pt-br') return 'Ensaio Grátis'
    return 'Free Trial'
  })

  const imageSrc = computed(() => {
    if (storeLocale.locale === 'pt-br') return isMobile() ? imagePtMobile : imagePt
    return isMobile() ? imageEnMobile : imageEn
  })

  function redirectBanner() {
    if (storeLocale.locale == 'pt-br') {
      window.location.href =
        'https://secure.campaigner.com/CSB/Public/Form.aspx?fid=1936917&ac=gpym'
    } else {
      window.location.href =
        'https://secure.campaigner.com/CSB/Public/Form.aspx?fid=1939772&ac=gpym'
    }
  }
</script>
<script lang="ts"></script>
<style scoped lang="css">
  img {
    width: 1254px;
    height: 124px;
    cursor: pointer;
  }

  @media screen and (max-width: 992px) {
    img {
      width: 95%;
      cursor: pointer;
      object-fit: cover;
      height: auto;
    }
    .m-top {
      margin-top: 50px;
    }
  }
  @media screen and (max-width: 769px) {
    .m-top {
      margin-top: 10px;
    }
  }
</style>
